import React from 'react';
import AssetCatalog from '../components/AssetCatalog';

const CompanyAssets = () => {
  return <AssetCatalog />;
};

export default CompanyAssets;